import React from 'react';

// import { Container } from './styles';

const AuthLayout: React.FC = ({ children }) => {
  return <div>{children}</div>;
};

export default AuthLayout;
